export const NoResults = () => {
  return (
    <img
      src="/icons/empty.svg"
      alt="empty"
      className="full h-full max-w-[240px] max-h-[240px] mx-auto"
    />
  );
};
